export const LABEL_REQUIRED = 'LABEL_REQUIRED';
export const LABEL_OPTIONAL = 'LABEL_OPTIONAL';
export const ROOT_FIELD = '$ROOT_FIELD$';